import React from 'react';
import Collapse from '@material-ui/core/Collapse';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';

interface IProps {
  children: any;
  disableCollapse?: boolean;
}

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
const CollapseOnScroll = (props: IProps) => {
  const { children, disableCollapse } = props;
  const trigger = useScrollTrigger({ threshold: 50 });

  if (disableCollapse) return children;
  return <Collapse in={!trigger}>{children}</Collapse>;
};

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default CollapseOnScroll;
